import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDeviceDetect } from "../../hooks/useDeviceDetect";
import { useAuthStore } from "../../store/useAuthStore";
import { useSportsLaunch } from "../../hooks/useSportsLaunch";
import {
  MenuPlayIcon,
  SearchStarIcon,
  CasinoIcon,
  SportsGameIcon,
  ProfileIcon,
} from "../icons/SvgIcons";

const loggedInItems = [
  { path: "/menu", label: "Menu", icon: "menu" },
  { path: "/explore", label: "Explore", icon: "search" },
  { path: "/", label: "Casino", icon: "casino" },
  { path: null, label: "Sports", icon: "sports", isSports: true },
  { path: "/mobile-user", label: "Profile", icon: "profile" },
];

const guestItems = [
  { path: "/menu", label: "Menu", icon: "menu" },
  { path: "/explore", label: "Explore", icon: "search" },
  { path: "/", label: "Casino", icon: "casino" },
  { path: null, label: "Sports", icon: "sports", isSports: true },
];

const renderIcon = (iconKey, isActive) => {
  const color = isActive ? "var(--color-accent-coral)" : "var(--color-text-muted)";
  switch (iconKey) {
    case "menu": return <MenuPlayIcon color={color} />;
    case "search": return <SearchStarIcon color={color} />;
    case "casino": return <CasinoIcon active={isActive} />;
    case "sports": return <SportsGameIcon active={isActive} />;
    case "profile": return <ProfileIcon color={color} />;
    default: return null;
  }
};

const MobileBottomTab = () => {
  const { isMobile } = useDeviceDetect();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("");
  const handleSportsLaunch = useSportsLaunch();

  const navItems = isAuthenticated ? loggedInItems : guestItems;

  useEffect(() => {
    const current = navItems.find((item) => item.path === location.pathname);
    setActiveTab(current?.label || "");
  }, [location.pathname, navItems]);

  if (!isMobile) return null;

  return (
    <nav className="btm-nav-wrapper">
      <div className="btm-nav-container">
        {navItems.map((item) => {
          const isActive = activeTab === item.label;

          if (item.isSports) {
            return (
              <div
                key={item.label}
                className={`btm-nav-item ${isActive ? "active" : ""}`}
                onClick={() => { setActiveTab("Sports"); handleSportsLaunch(); }}
                style={{ cursor: "pointer" }}
              >
                <div className="btm-nav-icon">
                  {renderIcon(item.icon, isActive)}
                </div>
                <span className="btm-nav-label" style={{ color: isActive ? "#FF5C5C" : "#9CA3AF" }}>
                  {item.label}
                </span>
              </div>
            );
          }

          return (
            <Link
              key={item.label}
              to={item.path}
              className={`btm-nav-item ${isActive ? "active" : ""}`}
              onClick={() => setActiveTab(item.label)}
            >
              <div className="btm-nav-icon">
                {renderIcon(item.icon, isActive)}
              </div>
              <span className="btm-nav-label" style={{ color: isActive ? "#FF5C5C" : "#9CA3AF" }}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomTab;
